import moment from 'moment'
import { ISO_8601_DURATION_REGEX } from '../constants/iso-8601-duration-regex'

/**
 * Simple convenience helper to verify if the provided string is formatted as ISO 8601 duration.
 *
 * @param {String} durationString - The string to be checked for its formatting.
 * @returns {boolean} Whether the input string is formatted as ISO 8601 duration string or not.
 */
export const isIso8601Duration = durationString => {
    return ISO_8601_DURATION_REGEX.test(durationString) && !isNaN(moment.duration(durationString).get('seconds'))
}
